import React, { useEffect, useState } from 'react'
import { DateTime } from 'luxon'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { QuestionTable } from '../../../../tables/question-table'
import { TableHelper } from '../../../../tables'

const Questions = observer(() => {
  const match = useRouteMatch<any>('/activities/assignments/:tab/:id/questions')
  const assignmentID = Number(match?.params?.id)
  const tab = String(match?.params?.id)

  const { assignmentStore } = useStores()
  const { assignmentOverviewStats, getAssignmentDetails } = assignmentStore

  useEffect(() => {
    if (!assignmentOverviewStats) {
      const endTime = DateTime.now()
      const startTime = endTime.plus({ days: -7 }).toISO().toString()
      getAssignmentDetails(assignmentID, startTime, endTime.plus({ days: -7 }).toISO())
    }
  }, [])

  const [tableHelper] = useState(
    new TableHelper('list_assignment_questions', 'questions', 'assignments', assignmentID, tab),
  )

  return <QuestionTable tableHelper={tableHelper} />
})

export const AssignmentsQuestionsTab = (props: any) => {
  const { id, mainTab } = props
  return {
    name: 'Questions',
    path: `/activities/assignments/${mainTab}/${id}/questions`,
    component: () => <Questions />,
  }
}
